import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Showreel from '../components/Showreel';
import BrandsMarquee from '../components/BrandsMarquee';
import About from '../components/About';
import Values from '../components/Values';
import Solutions from '../components/Solutions';
import Industries from '../components/Industries';
import FeaturedBrands from '../components/FeaturedBrands';
import CaseStudies from '../components/CaseStudies';
import Stats from '../components/Stats';
import Testimonials from '../components/Testimonials';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import WhatsAppWidget from '../components/WhatsAppWidget';

const HomePage = () => {
  return (
    <div className="relative">
      <Navbar />
      <main>
        <Hero />
        <Showreel />
        <BrandsMarquee />
        <About />
        <Values />
        <Solutions />
        <Industries />
        <FeaturedBrands />
        <CaseStudies />
        <Stats />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
      <WhatsAppWidget />
    </div>
  );
};

export default HomePage;
